export default "__VITE_ASSET__DMcaV7vX__"